import React from "react";
import styled from "styled-components";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import {
  PointTabColumn,
  PointTabContainer,
  PointTabText,
  STabBar,
} from "../Benefit/Point/PointTab";
import { authType } from "../../../pages/Login";

export const dashboardTabState = atom<number>({
  key: "dashboardTabState",
  default: 0,
});

export default function DashboardTab() {
  const auth = useRecoilValue(authType);

  const [tab, setTab] = useRecoilState(dashboardTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>유저 현황</PointTabText>

        <PointTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn
        onClick={() => {
          if (auth.dash) {
            setTab(1);
          }
        }}
        isDisabled={!auth.dash}
      >
        <PointTabText isActive={Boolean(tab === 1)}>파티 현황</PointTabText>
      </PointTabColumn>

      <PointTabColumn
        onClick={() => {
          if (auth.dash) {
            setTab(2);
          }
        }}
        isDisabled={!auth.dash}
      >
        <PointTabText isActive={Boolean(tab === 2)}>결제 현황</PointTabText>
      </PointTabColumn>

      <PointTabColumn
        onClick={() => {
          if (auth.dash) {
            setTab(3);
          }
        }}
        isDisabled={!auth.dash}
      >
        <PointTabText isActive={Boolean(tab === 3)}>쿠폰/포인트</PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const PointTabBar = styled.div<STabBar>`
  position: absolute;
  width: ${({ tab }) => (tab === 3 ? 85 : 66)}px;
  height: 3px;
  background-color: ${({ theme }) => theme.color.gray900};
  bottom: -8px;
  left: ${({ tab }) =>
    tab === 0 ? 0 : tab === 1 ? 87 : tab === 2 ? 174 : 260}px;
  transition: left 0.2s ease;
`;
